export const CycleReviewTypes = ["self", "manager", "peer", "upward"] as const;

export type CycleReviewType = (typeof CycleReviewTypes)[number];
